import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { Point } from 'src/features/points/types';

const RESOURCE = '/parkings/:parkingId/points/:pointId/';

interface DTO {
    parkingId: string;
    pointId: string;
    normal_card_enter: boolean;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, pointId, ...data }: DTO): Promise<Point> => {
    return axios.put(formatResourcePath(RESOURCE, { parkingId, pointId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdatePoint };
export type { DTO as UpdatePointDTO };
